export default __webpack_public_path__ + "static/Henry.Netzer_social-45bf3210b2655b33e11df9bc3f907f74.jpg";